const FAV_KEY = "toolbox_favorites";
const RECENT_KEY = "toolbox_recents";
const EVT = "toolbox_prefs_changed";

const read = (k) => {
  try { return JSON.parse(localStorage.getItem(k)) || []; } catch { return []; }
};
const write = (k, v) => {
  localStorage.setItem(k, JSON.stringify(v));
  window.dispatchEvent(new Event(EVT));
};

export const getFavorites = () => read(FAV_KEY);
export const isFavorite = (slug) => read(FAV_KEY).includes(slug);
export const toggleFavorite = (slug) => {
  const cur = read(FAV_KEY);
  const next = cur.includes(slug) ? cur.filter((s) => s !== slug) : [slug, ...cur];
  write(FAV_KEY, next);
  return next;
};

export const getRecents = () => read(RECENT_KEY);
export const addRecent = (slug) => {
  const cur = read(RECENT_KEY).filter((s) => s !== slug);
  write(RECENT_KEY, [slug, ...cur].slice(0, 8));
};

export const PREFS_EVENT = EVT;
